var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('section',{staticClass:"flex-cc dir-col flex-auto container"},[_c('h1',{staticClass:"mb-s"},[_vm._v("找不到頁面")]),_c('p',{staticClass:"mb-m"},[_vm._v("不好意思，找不到您搜尋的頁面......要重新尋找嗎？")]),_c('Button',{style:({padding: 0})},[_c('router-link',{style:({
          display: 'inline-block',
          padding: '6px 15px'
        }),attrs:{"to":"/"},domProps:{"textContent":_vm._s('回首頁')}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }